/* eslint-disable no-unused-vars */
export enum LanguageEnum {
  EN = 'en',
  PT = 'pt',
}
